// src/components/CreateQuote.js
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { db, auth } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { AuthContext } from '../context/AuthProvider';  // Assuming you have an AuthContext

export default function CreateQuote() {
    const [fontSize, setFontSize] = useState("12");
    const [quoteContent, setQuoteContent] = useState("");
    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);

    const { user } = useContext(AuthContext);  // Access the current user from context

    // Handle font size change and apply to selected text
    const handleFontSizeChange = (event) => {
        setFontSize(event.target.value);
    };

    // Handle the content change (for the quote input field)
    const handleContentChange = (event) => {
        setQuoteContent(event.target.innerHTML);
    };

    // Handle the bold toggle
    const handleBold = () => {
        setIsBold((prev) => !prev);
        document.execCommand("bold");
    };

    // Handle the italic toggle
    const handleItalic = () => {
        setIsItalic((prev) => !prev);
        document.execCommand("italic");
    };

    // Handle the underline toggle
    const handleUnderline = () => {
        setIsUnderline((prev) => !prev);
        document.execCommand("underline");
    };

    // Handle quote submission (saving to Firestore)
    const handleCreateQuote = async () => {
        if (!quoteContent.trim()) {
            alert("Please enter some content for the quote.");
            return;
        }

        try {
            // Add the quote to Firestore
            await addDoc(collection(db, "quotes"), {
                uid: user.uid,
                content: quoteContent,
                fontSize: fontSize,
                timestamp: serverTimestamp(),
            });
            alert("Quote created successfully!");
            setQuoteContent("");  // Reset the content field
        } catch (error) {
            console.error("Error creating quote: ", error);
            alert("Failed to create quote. Please try again.");
        }
    };

    return (
        <div className="container">
            <div className="row justify-content-center pt-5">
                <div className="col-10 card">
                    <div className="card-body">
                        <h4 className="text-center">Create Quote</h4>

                        {/* Text tools */}
                        <div className="tools d-flex justify-content-start">
                            {/* Font size selection */}
                            <select
                                className="px-3 ms-3 border-0 my-2"
                                value={fontSize}
                                onChange={handleFontSizeChange}
                            >
                                <option value="8">8</option>
                                <option value="10">10</option>
                                <option value="12">12</option>
                                <option value="14">14</option>
                                <option value="16">16</option>
                                <option value="18">18</option>
                                <option value="20">20</option>
                                <option value="22">22</option>
                                <option value="24">24</option>
                                <option value="26">26</option>
                                <option value="28">28</option>
                                <option value="30">30</option>
                            </select>

                            {/* Bold button */}
                            <button
                                className={`px-3 ms-3 border-0 my-2 ${isBold ? 'bg-light-yellow' : ''}`}
                                onClick={handleBold}
                            >
                                B
                            </button>

                            {/* Italic button */}
                            <button
                                className={`px-3 ms-3 border-0 my-2 ${isItalic ? 'bg-light-yellow' : ''}`}
                                onClick={handleItalic}
                            >
                                I
                            </button>

                            {/* Underline button */}
                            <button
                                className={`px-3 ms-3 border-0 my-2 ${isUnderline ? 'bg-light-yellow' : ''}`}
                                onClick={handleUnderline}
                            >
                                U
                            </button>
                        </div>

                        {/* Editable div for quote input */}
                        <div className="TextArea d-flex justify-content-center">
                            <div
                                contentEditable="true"
                                style={{
                                    resize: 'none',
                                    width: '100%',
                                    minHeight: '300px',
                                    border: '1px solid #ccc',
                                    padding: '10px',
                                    fontSize: `${fontSize}px`,
                                    outline: 'none',
                                }}
                                onInput={handleContentChange}
                            >
                                {quoteContent}
                            </div>
                        </div>
                    </div>

                    {/* Links to switch between CreatePoll and CreateQuote */}
                    <div className="other text-center mt-3">
                        <Link to='/create/CreatePoll' className='text-black text-decoration-underline'>
                            Create Poll?
                        </Link>
                    </div>

                    {/* Post button to create quote */}
                    <div className="post d-flex justify-content-center mt-4 mb-3">
                        <button onClick={handleCreateQuote} className="btn btn-secondary w-75">
                            Create Quote
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
